import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { Upload as UploadIcon, Close as CloseIcon } from "@mui/icons-material";
import FormLabel from "./FormLabel.jsx";

export const ImageSelector = ({
  label,
  value,
  onChange,
  accept = "image/*",
  sx = {},
  width = 150,
  height = 170,
  error = false,
  helperText = "",
  required = false,
}) => {
  const fileInputId = `image-upload-${label?.replace(/\s+/g, "-")}`;

  const handleFileChange = (e) => {
    console.log(e,"e")
    const file = e.target.files[0];
    if (file) {
      onChange(file);
    }
  };

  const handleRemove = (e) => {
    e.stopPropagation(); // prevent reopening file picker
    onChange(null);
    const input = document.getElementById(fileInputId);
    if (input) input.value = null;
  };

  const renderContent = () => {
    if (value) {
      return (
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: "100%",
            p: 1.5, // ✅ adds equal padding on all sides
            boxSizing: "border-box", // ensure padding stays inside box
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 1,
            overflow: "hidden",
          }}
        >
          {/* Image preview */}
          <img
            src={typeof value === "string" ? value : URL.createObjectURL(value)}
            alt="selected"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "fit", // ✅ maintains aspect ratio, fits inside box
              objectPosition: "center", // ✅ centers the image perfectly
              display: "block",
            }}
          />

          {/* ❌ Remove button */}
          <IconButton
            size="small"
            onClick={handleRemove}
            sx={{
              position: "absolute",
              top: 6,
              right: 6,
              backgroundColor: "rgba(0,0,0,0.55)",
              color: "white",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      );
    }

    // Empty-state: center icon + text
    return (
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          color: "text.secondary",
          gap: 1,
          px: 1,
          textAlign: "center",
        }}
      >
        <UploadIcon fontSize="medium" />
        <Typography variant="body2">Select Image</Typography>
      </Box>
    );
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, ...sx }}>
      {/* Optional label */}
      {label && <FormLabel label={label} required={required} />}

      {/* Upload box */}
      <label htmlFor={fileInputId} style={{ width: "fit-content" }}>
        <Box
          sx={{
            width,
            height,
            borderRadius: 2,
            cursor: "pointer",
            overflow: "hidden",
            position: "relative",
            display: "block",
            backgroundColor: "white", // makes shadow look crisp
            boxShadow: "0px 4px 12px rgba(0,0,0,0.15)", // ✅ black light shadow
          }}
        >
          <input
            type="file"
            id={fileInputId}
            accept={accept}
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          {renderContent()}
        </Box>
      </label>

      {/* Error message */}
      {error && (
        <Typography
          color="error"
          variant="caption"
          sx={{ mt: 0.5, display: "block" }}
        >
          {helperText}
        </Typography>
      )}
    </Box>
  );
};
